// column
export { default as AgendaColumn } from '../lib/Calendar/column/AgendaColumn.js';
export { default as EventColumn } from '../lib/Calendar/column/EventColumn.js';
// data
export { default as CrudManager } from '../lib/Calendar/data/CrudManager.js';
export { default as TimeRangeStore } from '../lib/Calendar/data/TimeRangeStore.js';
// feature
export { default as CalendarDrag } from '../lib/Calendar/feature/CalendarDrag.js';
export { default as CalendarFeature } from '../lib/Calendar/feature/CalendarFeature.js';
export { default as EventEdit } from '../lib/Calendar/feature/EventEdit.js';
export { default as EventMenu } from '../lib/Calendar/feature/EventMenu.js';
export { default as EventTooltip } from '../lib/Calendar/feature/EventTooltip.js';
export { default as ExternalEventSource } from '../lib/Calendar/feature/ExternalEventSource.js';
export { default as LoadOnDemand } from '../lib/Calendar/feature/LoadOnDemand.js';
export { default as Print } from '../lib/Calendar/feature/print/Print.js';
export { default as ScheduleMenu } from '../lib/Calendar/feature/ScheduleMenu.js';
export { default as TimeRanges } from '../lib/Calendar/feature/TimeRanges.js';
export { default as WeekExpander } from '../lib/Calendar/feature/WeekExpander.js';
// layout
export { default as LayoutDim } from '../lib/Calendar/layout/LayoutDim.js';
export { default as DayLayout } from '../lib/Calendar/layout/day/DayLayout.js';
export { default as FluidDayLayout } from '../lib/Calendar/layout/day/FluidDayLayout.js';
// mixin
export { default as CalendarStores } from '../lib/Calendar/mixin/CalendarStores.js';
// model
export { default as ProjectModel } from '../lib/Calendar/model/ProjectModel.js';
export { default as TimeRangeModel } from '../lib/Calendar/model/TimeRangeModel.js';
// util
export { default as EventSlots } from '../lib/Calendar/util/EventSlots.js';
export { default as EventSorter } from '../lib/Calendar/util/EventSorter.js';
// widget
export { default as AgendaView } from '../lib/Calendar/widget/AgendaView.js';
export { default as CalendarDatePicker } from '../lib/Calendar/widget/CalendarDatePicker.js';
export { default as CalendarRow } from '../lib/Calendar/widget/CalendarRow.js';
export { default as DaySelector } from '../lib/Calendar/widget/DaySelector.js';
export { default as DayView } from '../lib/Calendar/widget/DayView.js';
export { default as DayResourceCalendarRow } from '../lib/Calendar/widget/DayResourceCalendarRow.js';
export { default as DayResourceView } from '../lib/Calendar/widget/DayResourceView.js';
export { default as EventEditor } from '../lib/Calendar/widget/EventEditor.js';
export { default as EventList } from '../lib/Calendar/widget/EventList.js';
export { default as EventTip } from '../lib/Calendar/widget/EventTip.js';
export { default as ModeSelector } from '../lib/Calendar/widget/ModeSelector.js';
export { default as MonthView } from '../lib/Calendar/widget/MonthView.js';
export { default as OverflowPopup } from '../lib/Calendar/widget/OverflowPopup.js';
export { default as ResourceView } from '../lib/Calendar/widget/ResourceView.js';
export { default as Sidebar } from '../lib/Calendar/widget/Sidebar.js';
export { default as WeekView } from '../lib/Calendar/widget/WeekView.js';
export { default as YearView } from '../lib/Calendar/widget/YearView.js';
// widget mixin
export { default as CalendarMixin } from '../lib/Calendar/widget/mixin/CalendarMixin.js';
export { default as DateRangeOwner } from '../lib/Calendar/widget/mixin/DateRangeOwner.js';
export { default as DayCellCollecter } from '../lib/Calendar/widget/mixin/DayCellCollecter.js';
export { default as DayCellRenderer } from '../lib/Calendar/widget/mixin/DayCellRenderer.js';
export { default as EventRenderer } from '../lib/Calendar/widget/mixin/EventRenderer.js';
export { default as DaySelectable } from '../lib/Calendar/widget/mixin/DaySelectable.js';
// view mixin
export { default as EventNavigation } from '../lib/Calendar/view/mixin/EventNavigation.js';
export { default as EventSelection } from '../lib/Calendar/view/mixin/EventSelection.js';
// view
export { default as Calendar } from '../lib/Calendar/view/Calendar.js';


import GlobalEvents from '../lib/Core/GlobalEvents.js';
import BrowserHelper from '../lib/Core/helper/BrowserHelper.js';
import VersionHelper from '../lib/Core/helper/VersionHelper.js';
import Widget from '../lib/Core/widget/Widget.js';
import Toast from '../lib/Core/widget/Toast.js';
import Override from '../lib/Core/mixin/Override.js';
import DomHelper from '../lib/Core/helper/DomHelper.js';
import Calendar from '../lib/Calendar/view/Calendar.js';
(() => {
    //region Common
    const
        HOSTS            = [
            'bryntum.com',
            'cdpn.io',
            'react-gantt.com',
            'vue-gantt.com',
            'vue-scheduler.com',
            'react-scheduler.com',
            'angular-scheduler.com',
            'angular-calendar.com',
            'vue-calendar.com',
            'react-calendar.com',
            'lmctfy.net'
        ],
        ONE_DAY          = 1000 * 60 * 60 * 24,
        EXPIRING_CLASSES = [];
    if (!VersionHelper.isTestEnv && (HOSTS.some(host => location.host.includes(host)) || /\/docs/.test(location.href))) {
        return;
    }
    let initialized;
    function initExpiryHelper(owner, baseClass) {
        if (!initialized) {
            initialized = true;
            ExpiryHelper.construct({
                widget : owner
            });
        }
        // do not remove this line (used to distinguish trial bundles by regexp)
        owner.__foo = 'THISISTRIAL';
    }
    //endregion
    //region ExpiryHelper
    class ExpiryHelper {
        static construct(config) {
            const
                me            = this,
                product       = 'gantt',
                productName   = 'Gantt',
                version       = VersionHelper.getVersion(product),
                callHomeDelay = VersionHelper.isTestEnv ? 3000 : 1000 * 60,
                blockUrl      = BrowserHelper.queryString.blockUrl;
            Object.assign(me, {
                version,
                product,
                Product          : productName,
                verifyUrl        : VersionHelper.isTestEnv ? blockUrl : 'https://bryntum.com/verify/',
                blocked          : false,
                lastVersionCheck : 0,
                trialKey         : `b-${product}-trial-start`,
                versionCheckKey  : `b-${product}-verify-date`
            }, config);
            if (!VersionHelper.isTestEnv) {
                console.log(`Bryntum ${productName} Trial Version`);
            }
            me.cacheTrialStartTime();
            if (me.isExpired) {
                if (document.readyState === 'complete') {
                    me.onTrialExpired();
                }
                else {
                    document.addEventListener('readystatechange', () => {
                        if (document.readyState === 'complete') {
                            me.onTrialExpired();
                        }
                    });
                }
            }
            // Call home to log trial usage, assuming localStorage access works reliably
            // 1 min delay to be less easily detected
            setTimeout(() => {
                me.updateBlockedStatus();
            }, callHomeDelay);
        }
        static cacheTrialStartTime() {
            const
                me         = this,
                timeString = BrowserHelper.getLocalStorageItem(me.trialKey),
                time       = Number(timeString);
            if (time && !isNaN(time)) {
                me.trialStartTime = time;
            }
            me.trialStartTime = me.trialStartTime || Date.now();
            // First trial access, or no localstorage (no local storage meaning our expiration mechanism won't work. Only remote blocking will end the trial)
            BrowserHelper.setLocalStorageItem(me.trialKey, me.trialStartTime);
        }
        static get isExpired() {
            return this.blocked || (Date.now() - this.trialStartTime > ONE_DAY * 45) || window.bryntum?.[this.product]?.expired;
        }
        static updateBlockedStatus() {
            const
                me                  = this,
                saveVersionCheckKey = () => BrowserHelper.setLocalStorageItem(me.versionCheckKey, Date.now());
            me.lastVersionCheck = me.lastVersionCheck || BrowserHelper.getLocalStorageItem(me.versionCheckKey) || 0;
            // Max 1 version check per session / day
            if (me.lastVersionCheck && Date.now() - me.lastVersionCheck < ONE_DAY) {
                return;
            }
            if (me.verifyUrl) {
                const
                    url    = encodeURIComponent(location.href),
                    logUrl = `${me.verifyUrl}?id=${window.bryntum.license}&url=${url}`,
                    img    = new Image();
                img.onload = () => {
                    // 2x2 image means trial is blocked due to violation
                    if (img.naturalWidth === 2) {
                        me.blockTrial();
                    }
                    else {
                        // Just in case
                        saveVersionCheckKey();
                    }
                };
                img.onerror = () => {
                    saveVersionCheckKey();
                };
                img.src = logUrl;
            }
            else {
                saveVersionCheckKey();
            }
        }
        static onTrialExpired() {
            const rootEl = this.widget.rootElement;
            if (!this.expirationShown) {
                this.expirationShown = true;
                if (!VersionHelper.isTestEnv) {
                    console.warn(`Bryntum ${this.Product} trial version expired. Purchase a license at https://bryntum.com/store or contact us at https://bryntum.com/contact/ for licensing options.`);
                }
                rootEl.floatRoot && Toast.show({
                    html        : `Psst! Your Bryntum ${this.Product} trial has expired. Please see <a href="https://bryntum.com/store">our store</a> for licensing options`,
                    timeout     : 20000,
                    rootElement : rootEl
                });
            }
            DomHelper.removeEachSelector(rootEl, '.b-sch-dependency');
            DomHelper.forEachSelector(rootEl, '.b-container', element => {
                const widget = Widget.fromElement(element, 'widget');
                if (EXPIRING_CLASSES.some(cls => widget instanceof cls)) {
                    this.maskExpiredWidget(widget);
                }
            });
        }
        static blockTrial() {
            this.blocked = true;
            // Get rid of version check timestamp
            BrowserHelper.removeLocalStorageItem(this.versionCheckKey);
            // To force expired state: Set a fake early trial timestamp
            BrowserHelper.setLocalStorageItem(this.trialKey, 1);
            this.onTrialExpired();
        }
        static maskExpiredWidget(widget) {
            widget.mask({
                text  : '<h3 style="margin:0">Trial expired, <a href="https://bryntum.com/store" style="margin:0 3px; color:inherit">click here</a> to buy a license.</h3>',
                icon  : 'b-fa b-fa-frown',
                type  : 'trial',
                cover : 'target'
            });
        }
        static setWaterMark(element, {
            darkColor = 'rgba(255, 255, 255, 0.03)',
            lightColor = 'rgba(240, 240, 240, 0.54)'
        } = {}) {
            // Used for thumbnails
            if (BrowserHelper.queryString.thumb != null) {
                return;
            }
            const
                color     = DomHelper.themeInfo?.name?.toLowerCase().endsWith('-dark') ? darkColor : lightColor,
                svgString = `
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" style="font-family:sans-serif;font-weight:900;fill:${color}">
                    <defs>
                        <pattern id="company" patternUnits="userSpaceOnUse" width="400" height="200">
                            <text y="30" font-size="40" id="name">Bryntum</text>
                            <text y="120" x="200" font-size="24" id="trial">Trial Version</text>
                        </pattern>
                        <pattern id="pattern" xlink:href="#company" patternTransform="rotate(-45)">
                            <use xlink:href="#name" /><use xlink:href="#trial" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#pattern)" />
                </svg>`;
            element.style.backgroundImage = `url('data:image/svg+xml;base64,${window.btoa(svgString)}')`;
        };
    }
    //endregion
    //region Common override
    const applyBaseOverride = baseClass => {
        EXPIRING_CLASSES.push(baseClass);
        Override.apply(class {
            static get target() {
                return {
                    class : baseClass
                };
            }
            onPaintOverride() {
                const
                    me            = this,
                    setWatermarks = () => {
                        const targets = me.subGrids ? Object.values(me.subGrids) : [me];
                        for (const target of targets) {
                            if (target.element) {
                                ExpiryHelper.setWaterMark(target.element);
                            }
                        }
                    };
                initExpiryHelper(me, baseClass);
                setWatermarks();
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    setWatermarks();
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(me);
                }
            }
        });
    };
    //endregion
    if (typeof Calendar !== 'undefined') {
        EXPIRING_CLASSES.push(Calendar);
        const watermarkCalendar = calendar => {
            const
                { element, mode } = calendar,
                setWatermark      = selector => [...element.querySelectorAll(selector)].forEach(ExpiryHelper.setWaterMark);
            switch (mode) {
                case 'year' :
                    setWatermark('.b-yearview-content');
                    break;
                case 'agenda' :
                    setWatermark('.b-grid-subgrid');
                    break;
                default:
                    setWatermark('.b-dayview-day-detail');
            }
            setWatermark('.b-weeks-container');
        };
        Override.apply(class {
            static get target() {
                return {
                    class : Calendar
                };
            }
            onPaintOverride() {
                initExpiryHelper(this, Calendar);
                watermarkCalendar(this);
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    watermarkCalendar(this);
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(this);
                    this.queryAll(widget => widget.isCalendarMixin).forEach(widget => widget.collectEvents = () => new Map());
                }
            }
            onModeChange() {
                this._overridden.onModeChange.apply(this, arguments);
                watermarkCalendar(this);
            }
        });
    }
})();
(() => {
    // do not load analytics code for specific domains
    const ignoreDomainRe = /(.force.com|.lightning.com|.salesforce.com|lmctfy.net|qa.bryntum.com|qa2.bryntum.com)/;
    // document location might be null in firefox in salesforce
    if (!document.location || ignoreDomainRe.test(document.location.href) || window.top !== window) {
        return;
    }
    let id;
    const websiteUrls = [
        'bryntum.com',
        'cdpn.io'
    ];
    const
        products   = ['calendar', 'grid', 'gantt', 'scheduler', 'schedulerpro', 'taskboard'],
        frameworks = ['angular', 'react', 'vue', 'ionic'];
    websiteUrls.splice(0, 0, ...products.map(prod => frameworks.map(framework => `${framework}-${prod}`)).concat('bryntum.com').flat());
    if (document.location.host.match(websiteUrls.join('|'))) {
        id = 'G-1VY6776VJP';
    }
    else {
        id = 'G-H465KZDH8S';
    }
    const newScript = document.createElement('script');
    newScript.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    };
    document.head.appendChild(newScript);
    newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
})();
